export const defaultBaseOrderingModuleConfig = {
  orderingOrderUntilClosed: true,
  orderingAllowScheduledOrders: "always" as const,
  orderingShouldTotal: false,
  orderingExactTimeEstimate: true,
};
const defaultPaymentModuleConfig = {
  provider: "none",
};
export const defaultPickupModuleConfig = {
  pickupEnabled: false,
  pickupPaymentModuleConfig: defaultPaymentModuleConfig,
};
export const defaultDeliveryModuleConfig = {
  deliveryEnabled: false,
  deliveryPaymentModuleConfig: defaultPaymentModuleConfig,
  deliveryVerifyAddress: true,
  deliveryLatitude: 0,
  deliveryLongitude: 0,
  deliveryFee: 0,
  deliveryRadius: 0,
  deliveryRegionCode: "US",
};
